import axios from 'axios'

//import { isProduction, env } from '@/utils/env'

//var httpOk = null ;


function getUrlDomainGlob(nome_metodo)
{

  let result = "";

  if (location.hostname == "localhost") {
      result = location.protocol + "//emtool.local/";
  }

  if (location.hostname != "localhost") {

      result = location.protocol + "//" + location.hostname + "/";

  }

  return result + nome_metodo;


}

var main_domain = getUrlDomainGlob("");


class APIAssocUsersCompany {

  getUrlDomain(nome_metodo) {

    let result = "";

    if (location.hostname == "localhost") {
      result = location.protocol + "//emtool.local/";
    }

    if (location.hostname != "localhost") {

      result = location.protocol + "//" + location.hostname + "/";

    }

    return result + nome_metodo;


  }

  async getUtenti(user) {

    let formData = new FormData();

    formData.append("username", user);

    return axios.post(this.getUrlDomain("EmtAssocUserCmpGetUtentiApi"), formData, { 'Content-Type': 'multipart/form-data' });

  }

  async getOwner(user) {

    let formData = new FormData();

    formData.append("username", user);

    return axios.post(this.getUrlDomain("EmtGetOwnerApi"), formData, { 'Content-Type': 'multipart/form-data' });

  }

  async getUtenteSelezionato(user, user_sel) {

    let formData = new FormData();

    formData.append("username", user);
    formData.append("user_sel", user_sel);

    return axios.post(this.getUrlDomain("EmtAssocUserGetUserSelApi"), formData, { 'Content-Type': 'multipart/form-data' });

  }


  async getOwnerSelezionato(user, user_sel) {

    let formData = new FormData();

    formData.append("username", user);
    formData.append("user_sel", user_sel);

    return axios.post(this.getUrlDomain("EmtGetOwnerSelApi"), formData, { 'Content-Type': 'multipart/form-data' });

  }



  async updAssocAzi(chk_sel, id_azienda, user, user_sel, prod_sel) {

    let formData = new FormData();

    formData.append("username", user);
    formData.append("user_sel", user_sel);
    formData.append("chk_sel", chk_sel);
    formData.append("id_azienda", id_azienda);
    formData.append("prod_sel", prod_sel);

    return axios.post(this.getUrlDomain("EmtAssocUserUpdateApi"), formData, { 'Content-Type': 'multipart/form-data' });

  }

  async updAssocAziAll(chk_sel, user, user_sel) {

    let formData = new FormData();

    formData.append("username", user);
    formData.append("user_sel", user_sel);
    formData.append("chk_sel", chk_sel);

    return axios.post(this.getUrlDomain("EmtAssocUserAziAllUpdateApi"), formData, { 'Content-Type': 'multipart/form-data' });

  }


  async updateOwnerAzienda(chk_sel, id_azienda, user, user_sel, prod_sel) {

    let formData = new FormData();

    formData.append("username", user);
    formData.append("user_sel", user_sel);
    formData.append("chk_sel", chk_sel);
    formData.append("id_azienda", id_azienda);
    formData.append("prod_sel", prod_sel);

    return axios.post(this.getUrlDomain("EmtOwnerAziendaUpdateApi"), formData, { 'Content-Type': 'multipart/form-data' });

  }

  async updateOwnerAllAzienda(chk_sel, user, user_sel, product_sel) {

    let formData = new FormData();

    formData.append("username", user);
    formData.append("user_sel", user_sel);
    formData.append("chk_sel", chk_sel);
    formData.append("product_sel", product_sel);

    return axios.post(this.getUrlDomain("EmtOwnerAllAziendeUpdateApi"), formData, { 'Content-Type': 'multipart/form-data' });

  }

  async getUtentiOwner(user) {

    let formData = new FormData();

    formData.append("username", user);

    return axios.post(this.getUrlDomain("EmtGetUtentiOwnerApi"), formData, { 'Content-Type': 'multipart/form-data' });

  }

  async getUtenteOwnerSelezionato(user, user_sel, owner_sel) {

    let formData = new FormData();

    formData.append("username", user);
    formData.append("user_sel", user_sel);
    formData.append("owner_sel", owner_sel);

    return axios.post(this.getUrlDomain("EmtGetUserOwnerSelApi"), formData, { 'Content-Type': 'multipart/form-data' });

  }






}

export default new APIAssocUsersCompany({
  url: main_domain
})
